import Vimeo from '@u-wave/react-vimeo';

function VideoCard({ video, onClick, isMobile = false }) {
    return (
        <li className="tw-w-full">
            <div 
                className="tw-relative tw-overflow-hidden tw-w-full tw-h-0 tw-pb-[56.25%] tw-mb-4 tw-rounded-[10px] tw-bg-black tw-z-0 tw-cursor-pointer"
                onClick={onClick}
            >
                <div className="tw-absolute tw-top-0 tw-left-0 tw-w-full tw-h-full tw-pointer-events-none tw-overflow-hidden">
                    <Vimeo
                        video={video.embed}
                        showTitle={false}
                        showByline={false}
                        showPortrait={false}
                        controls={false}
                        muted={true}
                        paused={true}
                        className="tw-w-full tw-h-full tw-rounded-[10px]"
                        style={{ 
                            objectFit: 'cover',
                            width: '100%',
                            height: '100%'
                        }}
                        responsive={true}
                    />
                </div>
                {!isMobile && (
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="12.774"
                        height="12.774"
                        viewBox="0 0 10 12"
                        fill="none"
                        className="tw-absolute tw-top-1/2 tw-left-1/2 tw-transform tw--translate-x-1/2 tw--translate-y-1/2 tw-z-10 tw-pointer-events-none"
                    >
                        <path d="M0.383545 10.3989V0.663574L8.81519 5.53076L0.383545 10.3989Z" stroke="white" strokeWidth="0.766467" />
                    </svg>
                )}
            </div>

            <span className={`tw-block tw-text-black tw-font-['Poppins'] tw-font-normal tw-leading-[140%] tw-tracking-[0.166px] ${isMobile ? 'tw-text-[13px] tw-font-light tw-tracking-[0.13px]' : 'tw-text-[16.607px]'}`}>
                {video.title}
            </span>
        </li>
    );
}

export default VideoCard;
